import { Injectable } from '@angular/core';
import { ServiceService } from './service.service';

@Injectable({
  providedIn: 'root'
})
export class FacultadService {

  constructor( private servi: ServiceService ) { }

  public  getInformacion() { return this.servi.get('Facultades/getInformacion'); }

  public GuardarFacultad(dato) { return this.servi.post(`Facultades/postGuardarFacultad`, dato); }

  public GuardarPrograma(dato) { return this.servi.post(`Facultades/postGuardarPrograma`, dato); }

  public eliminarPrograma(id: number) { return this.servi.get('Facultades/EliminarPrograma/' + id); }

  public cambiarEstado(id: number) { return this.servi.get('Facultades/CambiarEstado/' + id); }
}
